import { render, staticRenderFns } from "./CallContacts.vue?vue&type=template&id=0374f822&scoped=true"
import script from "./CallContacts.vue?vue&type=script&lang=ts"
export * from "./CallContacts.vue?vue&type=script&lang=ts"
import style0 from "./CallContacts.vue?vue&type=style&index=0&id=0374f822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374f822",
  null
  
)

export default component.exports